export class GlobalVariables {
    public static filters: any = {};
    public static orden: any = {};

    public static textos: any = {};
}